module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.couldRender) ? _c('div', {
    attrs: {
      "id": "main-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "turnplate"
    }
  }, [_c('div', {
    staticClass: "outer-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "outer-2"
  }), _vm._v(" "), _c('div', {
    class: ['real-deg', _vm.outerPanelClass]
  }, [_c('div', {
    class: ['inner-1', _vm.panelRotateClass],
    style: (_vm.panelStyle)
  })]), _vm._v(" "), _c('div', {
    class: ['inner-2', _vm.pointerClass],
    on: {
      "click": _vm.play
    }
  }), _vm._v(" "), (_vm.activityStatus === 0) ? _c('div', {
    staticClass: "chance-left"
  }, [_vm._v("你今天还有"), _c('span', [_vm._v(_vm._s(_vm.chanceLeft))]), _vm._v("次抽奖机会")]) : (_vm.activityStatus >= 1 && _vm.activityStatus <= 3) ? _c('div', {
    staticClass: "chance-left"
  }, [_vm._v(_vm._s(_vm.activityStatusStr))]) : _vm._e(), _vm._v(" "), _vm._v(" "), _c('div', {
    staticClass: "btn",
    attrs: {
      "id": "btn1"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/intro/' + _vm.shopId
      }
    }
  }, [_vm._v("活动介绍")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "div",
      "to": {
        path: '/coupon'
      }
    }
  }, [_c('div', {
    staticClass: "btn",
    attrs: {
      "id": "btn2"
    }
  }, [_vm._v("我的奖品"), (_vm.awardCnt > 0) ? _c('span', [_vm._v(" " + _vm._s(_vm.awardCnt))]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('vm-error', {
    attrs: {
      "config": _vm.errorConfig
    }
  })])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-loader/lib/template-compiler.js?id=data-v-ec2e45aa!../~/vue-loader/lib/selector.js?type=template&index=0!./components/vue/turnplate-new.vue
 ** module id = 167
 ** module chunks = 3
 **/